<template>
  <svg
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="27.5"
      cy="27.5"
      r="27.5"
      fill="url(#paint0_linear_11269_14945)"
    />
    <path
      d="M28 15.8125C25.5895 15.8125 23.2332 16.5273 21.229 17.8665C19.2248 19.2056 17.6627 21.1091 16.7402 23.336C15.8178 25.563 15.5764 28.0135 16.0467 30.3777C16.5169 32.7418 17.6777 34.9134 19.3821 36.6179C21.0866 38.3223 23.2582 39.4831 25.6223 39.9533C27.9865 40.4236 30.437 40.1822 32.664 39.2598C34.8909 38.3373 36.7944 36.7752 38.1335 34.771C39.4727 32.7668 40.1875 30.4105 40.1875 28C40.1838 24.7688 38.8986 21.671 36.6138 19.3862C34.329 17.1015 31.2312 15.8162 28 15.8125ZM38.3125 28C38.3133 28.951 38.182 29.8976 37.9223 30.8125H33.4094C33.6969 28.9485 33.6969 27.0515 33.4094 25.1875H37.9223C38.182 26.1024 38.3133 27.049 38.3125 28ZM24.9531 32.6875H31.0469C30.4465 34.6546 29.4044 36.4584 28 37.9609C26.5962 36.458 25.5541 34.6543 24.9531 32.6875ZM24.4961 30.8125C24.1742 28.9513 24.1742 27.0487 24.4961 25.1875H31.5133C31.8351 27.0487 31.8351 28.9513 31.5133 30.8125H24.4961ZM17.6875 28C17.6867 27.049 17.818 26.1024 18.0777 25.1875H22.5906C22.3031 27.0515 22.3031 28.9485 22.5906 30.8125H18.0777C17.818 29.8976 17.6867 28.951 17.6875 28ZM31.0469 23.3125H24.9531C25.5535 21.3454 26.5957 19.5416 28 18.0391C29.4038 19.542 30.4459 21.3457 31.0469 23.3125ZM37.1793 23.3125H33.0051C32.479 21.3823 31.5923 19.5692 30.3918 17.9688C31.8422 18.3172 33.2002 18.9751 34.3726 19.8975C35.5449 20.8198 36.504 21.9848 37.184 23.3125H37.1793ZM25.6082 17.9688C24.4077 19.5692 23.521 21.3823 22.9949 23.3125H18.816C19.496 21.9848 20.4551 20.8198 21.6275 19.8975C22.7998 18.9751 24.1578 18.3172 25.6082 17.9688ZM18.816 32.6875H22.9949C23.521 34.6177 24.4077 36.4308 25.6082 38.0312C24.1578 37.6828 22.7998 37.0249 21.6275 36.1025C20.4551 35.1802 19.496 34.0152 18.816 32.6875ZM30.3918 38.0312C31.5923 36.4308 32.479 34.6177 33.0051 32.6875H37.184C36.504 34.0152 35.5449 35.1802 34.3726 36.1025C33.2002 37.0249 31.8422 37.6828 30.3918 38.0312Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11269_14945"
        x1="27.5"
        y1="0"
        x2="27.5"
        y2="55"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#357DF9" />
        <stop offset="1" stop-color="#590B73" />
      </linearGradient>
    </defs>
  </svg>
</template>
